import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function describeError(err, fallback = "Something went wrong. Please try again.") {
  if (err?.response) {
    const detail = err.response.data?.detail;
    if (detail != null) return formatApiError(detail);
    if (err.response.status === 401) return "Invalid email or password.";
    if (err.response.status === 404) return "Account not found.";
    if (err.response.status >= 500) return "Server error. Please try again shortly.";
    return fallback;
  }
  if (err?.request) return "Server unavailable. Please check your connection and try again.";
  return err?.message || fallback;
}

export default api;
